<div fxLayout="column" fxLayoutAlign="star start" class="w-100">
    <ui-kit-empty-state [items]="allAttachments"
                        backgroundColor="light"
                        class="mt-24 w-100"
                        [title]="'i18n_af_emptyStateTitleDocumentsNotExists'"
                        subtitle="i18n_af_emptyStateSubtitleDocumentsNotExists"
                        icon="ic_empty_state_document"/>
    @if (commonInformationAttachments?.length) {
        <af-documents-panel
            [attachments]="commonInformationAttachments"
            class="mt-24 w-100"/>
    }
    @for (transactionDocuments of transactionsAttachments; track transactionDocuments; let first = $first) {
        @if (transactionDocuments?.transactionAttachments?.length) {
            <af-documents-panel
                [attachments]="transactionDocuments.transactionAttachments"
                [id]="transactionDocuments.transactionId"
                class="mt-12 w-100"
                [class.mt-24]="!commonInformationAttachments?.length && first"/>
        }
    }
</div>
